<template>
  <!-- calculator section -->
	<div class="calc-outer-container extra-padding">
		<div class="container">
			<div class="row">
				<div class="col-lg-10 offset-lg-1">
					<div class="row align-items-center">
						<div class="col-sm-5">
							<div class="calculator-image-box">
								<img loading="lazy" src="img/goals-calc-image.webp" width="229" height="322" alt="Retirement calculator to know how much money you need to retire worry free">
							</div>
						</div>
						<div class="col-sm-7">
							<div class="goals-calc-container">
								<div class="steps-heading">
									<h2 class="hf_heading02">Tell us what you require</h2>
								</div>
								<!-- calculator section -->
								<div class="goals-calculator-box captcha-div">
								  <div class="calculator">
								    <form action="show-retirement-result" method="post" id="showRetResult">
								    	<input type="hidden" v-model="_token" name="_token">

								      <div class="form-group dynamic-input">
								        <label>I am</label>
								        <input type="number" id="currentAge" name="currentAge" v-model="currentAge" class="restDot numbersonly width-dynamic" :class="currentAgeMClass" placeholder="40"  @keyup="resetCalculation()" min="0" maxlength="2" @input="updatecrAgeVal()" required>
								        <span>years old and I want to retire</span>
								      </div>
											<div class="form-group dynamic-input">
								        <label>at the age of</label>
								        <input type="number" id="retAge" name="retAge" v-model="retAge" class="restDot numbersonly width-dynamic" :class="retAgeMclass" placeholder="60" @keyup="resetCalculation()" min="0" maxlength="2" @input="updateretAgeVal()">
								        <span>years.</span>
								      </div>
								      <div class="form-group dynamic-input">
								        <label for="name">On retirement, my monthly need would be<span class="inr-symbol hf_dark">&#8377;</span></label>
								        <input type="text" id="amount" name="amountReqd" v-model="amountReqd" class="restDot numbersonly" :class="amountReqdMClass" placeholder="75,000" min="0" maxlength="10" required>
								      </div>
								      <VueRecaptcha 
                        sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" 
                        ref="recaptcha"
                        size="invisible"
                        :load-recaptcha-script="true" 
                        @verify="recaptchaVerified" 
                        @expired="resetCaptcha">
                      </VueRecaptcha>
								      <div class="notification-message">
								      	<p v-show="showError" class="errorMessage inflation-text hf_bodytext02">
								      		<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                  				{{ showErrorText }}
                				</p>
                			</div>
								      <div class="button-container">								        
								        <button type="button" class="btn-primaryNoIcon lg-primarynoIcon" @click.stop="showResult()">Know more</button>
								      </div>
								    </form>
								  </div>
								</div>
								<!-- end calculator section -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- end calculator section -->
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
export default {
	components: {
    VueRecaptcha
  },
  created() {},
  data() {
    return {
    	_token : this.$token,
    	goalType: 'RET',
    	currentAgeMClass: '',
    	retAgeMclass: '',
    	amountReqdMClass: '',
    	mandatoryClassName: 'redunderline',
    	showErrorText: '',
    	showError: false,
    	recaptchaToken:'',
    	currentAge: '',
    	retAge: '',
    	amountReqd: '',
    };
  },
  props: {},
  watch: {
	amountReqd(){
		var res =  this.formatAmount(this.amountReqd)
		this.amountReqd = res;
    },
  },
  mounted(){
  	// console.log(this);
  },
  methods: {
  	updatecrAgeVal: function(){
      var element = event.target;
      var maxlength = element.getAttribute('maxlength');
      if(this.currentAge.toString().length > maxlength){
        let number = this.currentAge;
        this.currentAge = number.toString().substring(0, number.toString().length - 1);
      }
    },
    updateretAgeVal: function(){
      var element = event.target;
      var maxlength = element.getAttribute('maxlength');
      if(this.retAge.toString().length > maxlength){
        let number = this.retAge;
        this.retAge = number.toString().substring(0, number.toString().length - 1);
      }
    },
    resetCaptcha() {
    //   console.log("resetCaptcha");
      this.$refs.recaptcha.reset();
      this.recaptchaToken = "";
    },
    recaptchaVerified(token) {
    //   console.log("recaptchaVerified");
      if (token ) this.recaptchaToken = token;
  		// console.log("recaptchaToken="+ this.recaptchaToken);
  		document.getElementById("showRetResult").submit();
    },
  	showResult(){
  		// console.log("Click event triggered");
  		// console.log(this.amountReqd);
  		// console.log(this.retAge);
  		// console.log(this.currentAge);

  		//Check for validation and collect data for calculations
  		//======================================================
  		let amountReqd = this.amountReqd;
  		let retAge = this.retAge;
  		let currentAge = this.currentAge;

  		if(amountReqd == "" || amountReqd == undefined || retAge == "" || retAge == undefined || currentAge == "" || currentAge == undefined){
  			this.showErrorText = "Please enter mandatory data first";
  			this.showError = true;

  			// Check for mandatory fields
  			//==============================
  			if(amountReqd == "" || amountReqd == undefined){
  				this.amountReqdMClass = this.mandatoryClassName;
  			}else{
  				this.amountReqdMClass = "";
  			}

  			if(retAge == "" || retAge == undefined){
  				this.retAgeMclass = this.mandatoryClassName;
  			}else{
  				this.retAgeMclass = "";
  			}

  			if(currentAge == "" || currentAge == undefined){
  				this.currentAgeMClass = this.mandatoryClassName;
  			}else{
  				this.currentAgeMClass = "";
  			}
  		}else{	
  			//remove all redunderline class for mandatory
        //============================================
        this.amountReqdMClass = "";
        this.retAgeMClass = "";
        this.currentAgeMClass = "";
        
  			//Check all the basic validations eg.age, amt
				//=============================================
				axios.post('/chkRetGoalValidations',{amountReqd: amountReqd, retAge: retAge, currentAge: currentAge, calcReq: 0, _token: this.$token})
        .then((response)=>{
        	// console.log(response);
        	let resData = response.data;
        	if(resData.status == true){
						this.showErrorText = "";
			    	this.showError = false;
        		// Show result on next page
					  //==================================================
						// this.$nextTick is added because above form is submitted before values changed in form
						//--------------------------------------------------------
				  	// this.$nextTick(() => {

			    		// Trigger clevertap event
				    	//===================================================
							// clevertap.event.push("Retirement Calculator", {
							//   "page name": window.location.pathname,
							//   "Current Age": currentAge,
							//   "Retire Age": retAge,
							//   "Monthly Need": amountReqd,
							// });

							//execute captcha call here
							//=========================================
							this.$refs.recaptcha.execute();
			    	// 	});
        	}else{
        		if(resData.error == undefined){
        			this.showErrorText = "Page session expired, Please refresh the page";
  						this.showError = true;
        		}else{
        			this.showErrorText = resData.error;
  						this.showError = true;
        		}
        		//Reset captcha called
			  		//=====================================
			  		this.resetCaptcha();
        	}
        }).catch(response => {
		        console.log(response.data);
		    })
  		}
  	},
  	resetCalculation(){
      // On keyup of field show button for calculation and hide result 
			//================================================================
			this.showErrorText = "";
    	this.showError = false;
    }
  },
};
</script>
